import React, { useState, useEffect, useContext } from "react";
import axiosShopWrapper from "../../services/globalService";
import { IntContainer, Title, Button2, StyledForm, StyledGoBack } from "./setup.style";
import LeftArrow from "../../img/Left_Arrow.svg";
import FixelDataContext from "../../context/FixelDataContext";
import facebookAccountData from "../../devData/facebookAccountData";
import { useHistory } from "react-router-dom";

const SelectFBAccount = () => {
  const history = useHistory();
  const { elData, setFullFixelData } = useContext(FixelDataContext);
  const [fbAccountData, setFbAccountData] = useState([]);
  const [selectedAccountName, setSelectedAccountName] = useState({});
  const [selectedAccountIndex, setSelectedAccountIndex] = useState(null);

  const connectFBAccount = async (e) => {
    e.preventDefault();
    // only for local dev
    // setFullFixelData({
    //   ...fullFixelData,
    //   FBIntegrationStatus: "connected",
    // });
    // return history.push("/setup");
    // for prod:
    // try {
    //   const res = await axiosShopWrapper("post", `/fixelData/connectFacebook?token=${sessionStorage.fbToken}`, {
    //     account: e.target.adAccount.value,
    //     pixel: e.target.pixel.value,
    //   });
    //   console.log("🚀 ~ file: SelectFBAccount.js ~ line 31 ~ connectFBAccount ~ res", res);
    //   if (res && res.success === "true") {
    //     console.log("🚀 ~ file: SelectFBAccount.js ~ line 31 ~ connectFBAccount ~ res", res);
    //     setFullFixelData({
    //       ...fullFixelData,
    //       FBIntegrationStatus: "connected",
    //     });
    //   } else {
    //     setFullFixelData({
    //       ...fullFixelData,
    //       FBIntegrationStatus: "failed",
    //     });
    //   }
    //   history.push("/setup");
    // } catch (e) {
    //   console.log("🚀 ~ file: SelectFBAccount.js ~ line 28 ~ connectFBAccount ~ e", e);
    // }
  };

  useEffect(() => {
    let didCancel = false;
    const getFbAccountData = async () => {
      // only for local dev:
      // return setFbAccountData(facebookAccountData);

      // for prod:
      try {
        const response = await axiosShopWrapper(
          "get",
          `/fixelData/facebookAccountData?fb_id=${sessionStorage.fbId}&token=${sessionStorage.fbToken}`,
        );
        if (!didCancel) {
          setFbAccountData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getFbAccountData();
    return () => {
      didCancel = true;
    };
  }, []);

  useEffect(() => {
    fbAccountData[0] && setSelectedAccountIndex(0);
  }, [fbAccountData]);

  const renderAdAccountOptions = () => {
    if (selectedAccountIndex === null) {
      return <option value="No ad accounts were found">No ad accounts were found</option>;
    }
    if (fbAccountData.length) {
      return fbAccountData.map((account) => {
        return (
          <option key={account.account_id} value={account.id}>
            {account.name} ({account.account_id})
          </option>
        );
      });
    }
  };

  const validateAccountData = (account) => {
    if (account) return account.hasOwnProperty("adspixels");
  };

  const renderPixelOptions = () => {
    if (selectedAccountIndex === null) {
      return <option value="Please select an account">Please select an account</option>;
    }
    if (!validateAccountData(fbAccountData[selectedAccountIndex])) {
      return <option value="Please select an account">Please select an account with pixels</option>;
    }

    const selectedAccount = fbAccountData[selectedAccountIndex].adspixels.data;

    return selectedAccount.map((pixel) => {
      return (
        <option key={pixel.id} value={pixel.id}>
          {pixel.name} ({pixel.id})
        </option>
      );
    });
  };

  return (
    <IntContainer>
      <StyledGoBack onClick={() => history.goBack()}>
        <img src={LeftArrow} alt="arrow left" /> Go Back
      </StyledGoBack>
      <Title align="left">Connect Fixel with a Facebook&nbsp;account</Title>
      {/* TODO: Add loading spinner */}
      <StyledForm onSubmit={connectFBAccount}>
        <label htmlFor="adAccount">
          Select Ad Account: <span>*</span>
        </label>

        <select
          required
          name="adAccount"
          id="adAccount"
          disabled={selectedAccountIndex === null}
          value={selectedAccountName}
          onChange={(e) => {
            setSelectedAccountName(e.target.value);
            setSelectedAccountIndex(e.target.selectedIndex);
          }}>
          {renderAdAccountOptions()}
        </select>

        <label htmlFor="pixel">
          Select Pixel: <span>*</span>
        </label>
        <select
          name="pixel"
          id="pixel"
          required
          disabled={selectedAccountIndex === null || !validateAccountData(fbAccountData[selectedAccountIndex])}>
          {renderPixelOptions()}
        </select>
        <Button2 type="submit">Connect</Button2>
      </StyledForm>
    </IntContainer>
  );
};
export default SelectFBAccount;
